module.exports = __webpack_public_path__ + "img/attendance2.fb349ab1.jpg";